import React, { Component } from 'react';
import { NavigationButton, NavigationButtonGroup } from 'web-ui-components/lib/navigation/buttons';
import { ContinueButton } from './Submit/ContinueButton';
import { ExitButton } from './Submit/ExitButton';
import { ExitModal } from './Submit/ExitModal';

import { CASE_ID } from '../utils/constants';
import { redirectToExit } from '../store/dataCapture/actions';
import { selectors as configSelectors } from '../infrastructure/config';
import { selectors as caseSelectors } from '../infrastructure/cases';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getHeaderAttribute, showHeaderUtility } from '../utils/headerUtil';
import { content } from '../infrastructure/content/selectors';

import { redirectToPreviousRoute } from '../store/dataCapture/actions';

class Submit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isExitModalOpen: false
    };
    this.toggleExitModal = this.toggleExitModal.bind(this);
  }

  toggleExitModal() {
    this.setState({
      ...this.state,
      isExitModalOpen: !this.state.isExitModalOpen
    });
  }

  render() {
    const { isExitModalOpen } = this.state;
    const {
      submitButtonText,
      disabled,
      hideExit = false,
      exitButtonText,
      saveEnabled,
      handleExit,
      username,
      onClick,
      location,
      externalContent,
      showLoadingScreen,
      redirectToPreviousRoute
    } = this.props;

    const { pathname } = location;
    const { isBackNavigationNeeded } = getHeaderAttribute(pathname, externalContent, '');

    const showUtilityNavigation = showHeaderUtility(pathname);

    const backClick = () => {
      redirectToPreviousRoute(pathname);
    };
    const showBackButton = !showLoadingScreen && showUtilityNavigation && isBackNavigationNeeded;

    return (
      <div>
        <NavigationButtonGroup
          secondaryButtons={
            showBackButton && (
              <NavigationButton.Secondary
                labelText={externalContent.headerBackButtonTitle}
                onClick={backClick}
              />
            )
          }
          tertiaryButtons={
            !hideExit && (
              <ExitButton
                onClick={this.toggleExitModal}
                saveEnabled={saveEnabled}
                exitButtonText={exitButtonText}
              />
            )
          }
          primaryButton={
            <ContinueButton
              submitButtonText={submitButtonText}
              disabled={disabled}
              onClick={onClick}
            />
          }
        />

        {!hideExit &&
          ExitModal({
            toggleModal: this.toggleExitModal,
            handleExit,
            saveEnabled,
            username,
            isExitModalOpen
          })}
      </div>
    );
  }
}

const actionCreators = {
  handleExit: redirectToExit,
  redirectToPreviousRoute
};

const mapStateToProps = state => ({
  saveEnabled: !!configSelectors.getSingleEntry(state, CASE_ID),
  username: caseSelectors.getUsername(state),
  location: state.router.location,
  externalContent: content(state)
});

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Submit);
